import React, { useMemo } from 'react';
import { checkValue } from 'src/components/common/helper';

export const useExtractSignupText = (signInMessageText: string) => {
  let signInText = {
    signupMesage: '',
    signupCtaText: '',
  };
  if (checkValue(signInMessageText)) {
    signInText = useMemo(() => {
      const start = signInMessageText.indexOf('<u>');
      const end = signInMessageText.indexOf('</u>');
      if (start && end) {
        const linkText = signInMessageText.slice(start + 3, end);
        return {
          signupMesage: signInMessageText.slice(0, start),
          signupCtaText: linkText,
        };
      }
      return {
        signupMesage: signInMessageText,
        signupCtaText: '',
      };
    }, [signInMessageText]);
  }

  return signInText;
};
